/**
 * Format a date-time value with the CLDR-conventional layout for the
 * device's raw `navigator.language`, not the app's allowlisted locale set.
 *
 * Uses `Intl.DateTimeFormat` with `dateStyle: 'medium'` + `timeStyle: 'short'`
 * so every locale resolves to its native rendering:
 *   en-US → "Jun 5, 2026, 8:30 PM"
 *   en-GB → "5 Jun 2026, 20:30"
 *   de-DE → "05.06.2026, 20:30"
 *   ja-JP → "2026/06/05 20:30"
 *
 * Going through Intl avoids moment's `lll` token, which reads `moment.locale()`
 * and therefore folds every unsupported locale back to en-US visuals via
 * `constants/supported-locales.js`.
 *
 * @param {string|Date|number} value - ISO string, Date, or epoch ms
 * @param {string} [timeZone] - IANA zone (e.g. "America/Los_Angeles")
 * @returns {string}
 */
function formatDateTime(value, timeZone) {
  if (value === null || value === undefined || value === '') {
    return '';
  }

  const date = value instanceof Date ? value : new Date(value);

  if (Number.isNaN(date.getTime())) {
    return '';
  }

  const locale = window.navigator.language || 'en-US';
  const options = { dateStyle: 'medium', timeStyle: 'short' };

  if (timeZone) {
    options.timeZone = timeZone;
  }

  return new Intl.DateTimeFormat(locale, options).format(date);
}



export default formatDateTime;
